module.exports = __webpack_public_path__ + "media/images/ligne-pink-03c7aaa3.png";